import { Api } from '@axiom/ui';
import type { Contact } from '@axiom/validation';

import { EnvUtil } from '../utils/env-util';

class ContactApiClass extends Api {
  constructor() {
    super({
      domain: EnvUtil.clientApiBase,
    });
  }

  readContact(contactId: Contact['id']) {
    return super.read<{ data: Contact }>({
      endpoint: `/contacts/${contactId}`,
      method: 'GET',
    });
  }

  async updateContact(contactId: Contact['id'], body: Partial<Contact>) {
    return super.write<{ data: Contact }>({
      endpoint: `/contacts/${contactId}`,
      method: 'PATCH',
      body,
    });
  }

  async refreshContact(contactId: Contact['id']) {
    return super.invalidate(`/contacts/${contactId}`);
  }
}

export const ContactApi = new ContactApiClass();
